module.exports = __webpack_public_path__ + "static/img/智慧网银云2.3e4f7f6b.png";